import React, { useState } from "react";
import { Sugestions } from "./_Sugestions";

export function Tags({ tags, selectedTag, setSelectedTag }) {
    const [theTags, setTags] = useState([]);

    function filterTags(term) {
        setTags(
            tags
                .filter((category) => {
                    return category.name.toLowerCase().indexOf(term.toLowerCase() || "") !== -1;
                })
                .slice(0, 4)
        );
    }

    return (
        <React.StrictMode>
            <fieldset className="tags">
                <span className="title">
                    <i className="icon"></i>
                    {tagsTxt}
                </span>
                <input type="search" id="searchTags" placeholder={findTagsTxt} onChange={(e) => filterTags(e.target.value)} />
                <Sugestions categories={theTags} selectedCategory={selectedTag} setSelectedCategory={setSelectedTag} />
            </fieldset>
        </React.StrictMode>
    );
}
